import { render } from "./VideoPresident.vue?vue&type=template&id=20ddd8e6"
import script from "./VideoPresident.vue?vue&type=script&lang=js"
export * from "./VideoPresident.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__